import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core'
import {Observable} from 'rxjs';
import {environment} from "../../../../../../environments/environment";
import {Payload} from "../../../../core/service/payload/payload";

@Injectable()
export class RephraseTextService {
    constructor(private httpClient: HttpClient) {
    }

    execute(payload: RephraseTextServicePayload): Observable<RephraseTextServiceResult> {
        return this.httpClient.post<RephraseTextServiceResult>(environment.webserviceUrl + '/api/communication/ai/text-rephrasing',
            payload);
    }
}

export class RephraseTextServicePayload implements Payload {
    text: string;
    role: string;
    options: RephraseTextServiceOptionPayload;

}

export class RephraseTextServiceOptionPayload implements Payload {
    temperature: number;
}

export class RephraseTextServiceResult {
    text: string;
}
